const option = [
    { id: 'increase', name: 'เพิ่ม' },
    { id: 'decrease', name: 'ลด' }
]

export default {
    option: option
};